import { combineReducers } from 'redux'
import selected from './get-one'
import editOne from './edit'
import editOneBusinessName from './edit-business-name'
import editOneSmallLogo from './edit-small-logo'
import editOneBigLogo from './edit-big-logo'

const reducer = combineReducers({
  selected,
  editOne,
  editOneBusinessName,
  editOneSmallLogo,
  editOneBigLogo
})

export default reducer
